import { render, staticRenderFns } from "./purchase-payments.vue?vue&type=template&id=971a9c8c&scoped=true"
import script from "./purchase-payments.vue?vue&type=script&lang=js"
export * from "./purchase-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971a9c8c",
  null
  
)

export default component.exports